import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SocialIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Social",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.45 2H5.55C3.61 2 2.03 3.57 2.03 5.52v14.01c0 1.94 1.57 3.52 3.52 3.52h2.58c.48 0 .87.39.87.87v5.16c0 .52.42.93.94.93.28 0 .53-.12.71-.32l5.52-6.35c.16-.18.39-.3.66-.3h9.64c1.94 0 3.52-1.57 3.52-3.52v-14c0-1.94-1.57-3.52-3.52-3.52Zm-4.33 8.75h-2.63v3.48h2.63c.48 0 .87.39.87.87v.04c0 .48-.39.86-.86.87H19.5v2.63a.87.87 0 0 1-1.74 0v-2.63h-3.5v2.63a.87.87 0 0 1-1.74 0v-2.63H9.88a.87.87 0 0 1 0-1.74h2.63v-3.5H9.88c-.48 0-.86-.38-.87-.86v-.02c0-.48.39-.87.87-.87h2.63V6.39a.87.87 0 0 1 1.74 0v2.63h3.48V6.39a.87.87 0 0 1 1.74 0v2.63h2.63c.48 0 .87.39.87.87v.02c0 .47-.37.85-.83.87Zm-7.86.01h3.48v3.48h-3.48z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M13.29 20.14c-.63 0-1.14-.51-1.14-1.14V7.57a1.14 1.14 0 1 1 2.28 0V19c0 .63-.51 1.14-1.14 1.14M17.86 20.14c-.63 0-1.14-.51-1.14-1.14V7.57a1.14 1.14 0 1 1 2.28 0V19c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M21.29 16.71H9.86a1.14 1.14 0 1 1 0-2.28h11.43a1.14 1.14 0 1 1 0 2.28M21.29 12.14H9.86a1.14 1.14 0 1 1 0-2.28h11.43a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3 30.43c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06V5.29c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43v16c0 1.89-1.54 3.43-3.43 3.43H9.19L3.81 30.1c-.22.22-.51.33-.81.33M5.29 4.14c-.63 0-1.14.51-1.14 1.14v21.24l3.76-3.76c.21-.21.51-.33.81-.33h17.14c.63 0 1.14-.51 1.14-1.14v-16c0-.63-.51-1.14-1.14-1.14H5.29Z"
      })]
    })
  }));
};
SocialIcon.displayName = 'SocialIcon';